import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store.ts';
import { api } from '../lib/api.ts';
import type { MyPermissionsDto } from '@pokerroom/types';

/**
 * 取得當前使用者合併權限（多角色聯集）
 * 登入後自動載入，結果存入 auth store 供側邊欄過濾使用
 */
export function usePermissions() {
  const user = useAuthStore((s) => s.user);
  const setPermissions = useAuthStore((s) => s.setPermissions);

  return useQuery({
    queryKey: ['my-permissions'],
    queryFn: () =>
      api.get<MyPermissionsDto>('/auth/my-permissions').then((data) => {
        setPermissions(data.visiblePages, data.allowedActions);
        return data;
      }),
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });
}
